import { AuthActionTypes } from 'types/store/actions/constants';
import { AuthActions } from 'types/store/actions/auth';
import { AppThunk } from 'store/store';
import { authSource } from 'sources';
import { logout, setToken, setDomain } from 'utils/auth';
import Role from 'types/Role';

export const setLoading = (isLoading: boolean): AuthActions => ({
  type: AuthActionTypes.SET_LOADING,
  payload: isLoading,
});

export const loginError = (error: string): AuthActions => ({
  type: AuthActionTypes.LOGIN_ERROR,
  payload: error,
});

export const listRolesSuccess = (roles: Role[]): AuthActions => ({
  type: AuthActionTypes.LIST_ROLES_SUCCESS,
  payload: roles,
});

export const logIn = (
  email: string,
  password: string,
  code: string
): AppThunk => async (dispatch: any): Promise<void> => {
  dispatch(setLoading(true));
  try {
    const token = await authSource.authenticate(email, password, code);
    setToken(token);
    setDomain(code);
    const roles = await authSource.roles();

    if (roles.length) {
      dispatch(listRolesSuccess(roles));
    } else {
      logout();
      dispatch(
        loginError("You don't have enough permissions to use Kiosk app.")
      );
    }

    dispatch(setLoading(false));
  } catch (e) {
    if (e.response && e.response.status >= 500) {
      dispatch(
        loginError('Something went wrong. Please contact us if this continues.')
      );
    } else {
      logout();

      /*
        NOTE:
        Group code issue is currently a network error because of how we set API domain in BaseSource.
        When that process is refactored, we should have a way to directly detect bad group code.
        Until then, bad group code has no response status and has to be caught with login credential issue.
      */
      dispatch(loginError('Login credentials or group code incorrect.'));
    }
  }
};
